import { render, staticRenderFns } from "./PurchasesCreator.vue?vue&type=template&id=c391800c&scoped=true&"
import script from "./PurchasesCreator.vue?vue&type=script&lang=ts&"
export * from "./PurchasesCreator.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasesCreator.vue?vue&type=style&index=0&id=c391800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c391800c",
  null
  
)

export default component.exports